<template lang="pug">
  #accept-reset-password
    HeaderForLogin
    b-card.mx-auto.body-width(header-tag="header")
      b-container(fluid="fluid")
        .mail-box.mx-auto.justify-content-center.text-center
          p.mt-3.text-left.white-space {{text_content}}
          b-table-simple.my-4.rounded(responsive="responsive", bordered)
            b-tbody
              b-tr
                b-th.alert-secondary.mail-label メールアドレス
                b-td.text-left {{e_mail}}
          p.text-left.white-space.text_caution {{text_caution}}
          router-link(:to="{name: 'Login'}") ログイン画面へ
</template>

<script>
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

export default {
  name: "AcceptResetPassword",
  components: {
    HeaderForLogin
  },
  props: {
    e_mail: {type: String, required: true},
  },
  data() {
    return {
      text_content: "下記のメールアドレスへパスワードリセットURLを記載した\n"
          + "件名「パスワードリセット画面へのご案内」\n"
          + "メールを送信いたしました。",
      text_caution: "※メールに記載されている「パスワードリセットURL」をクリックしていただくことで、\n"
          + "　登録完了となります。\n"
          + "※メール送信後、24時間を超過しますと、セキュリティ保持のため有効期限切れとなります。\n"
          + "　その場合は再度、最初からお手続きをお願いいたします。",
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.mail-box {
  width: 600px;
}
.mail-label {
  width: 200px;
}
.white-space {
  white-space: pre-wrap;
}
.text_caution {
  font-size: smaller;
  color: red;
}
</style>